<template>
    <div id="ioArchPanel" class="panel-group">
        <div id="intraoralArchPanel" ref="intraoralArchPanel" class="collapse list-group arch-panel ">
            <div class="arch-settings">
                <li class="list-group-item setting-item active">Settings</li>
                <li class="list-group-item setting-item">
                    <label class="setting-ctrl">
                        <span class="check-label">Move Points Symmetricallly</span>
                        <input type="checkbox" class="check-input" v-model="editContext.symmPoints"
                            @change="setSymmPoints($event)">
                    </label>

                    <label class="setting-ctrl">
                        <span class="check-label">Show Measure Lines</span>
                        <input type="checkbox" class="check-input" v-model="editContext.showLines"
                            @change="setShowLines($event)">
                    </label>
                </li>
                <li v-show="commonContext.hasUpper" class="list-group-item setting-item active">Crowding Upper</li>
                <li v-show="commonContext.hasUpper" class="list-group-item setting-item">
                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>3 to 3: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.upperTeethFirstSixSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.upperArchFirstSixSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(upperFirstSixDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(upperFirstSixDelta) }}</b></span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label"></span>
                    </label>

                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>5 to 5: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.upperTeethPremolarSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.upperArchPremolarSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(upperPremolarDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(lowerFirstSixDelta) }}</b></span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label"></span>
                    </label>

                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>All Teeth: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.upperTeethAllSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.upperArchAllSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(upperAllDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(upperAllDelta) }}</b></span>
                    </label>
                </li>

                <li v-show="commonContext.hasLower" class="list-group-item setting-item active">Crowding Lower</li>
                <li v-show="commonContext.hasLower" class="list-group-item setting-item">
                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>3 to 3: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.lowerTeethFirstSixSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.lowerArchFirstSixSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(lowerFirstSixDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(lowerFirstSixDelta) }}</b></span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label"></span>
                    </label>

                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>5 to 5: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.lowerTeethPremolarSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.lowerArchPremolarSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(lowerPremolarDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(lowerPremolarDelta) }}</b></span>
                    </label>
                    <label class="setting-ctrl">
                        <span class="check-label"></span>
                    </label>

                    <label class="analysis-ctrl">
                        <span class="analysis-label selectable"><b>All Teeth: </b></span>
                        <span class="analysis-label selectable">Teeth Sum = {{
                            commonContext.lowerTeethAllSum.toFixed(2)
                        }} mm</span>
                        <span class="analysis-label selectable"> Arch = {{
                                commonContext.lowerArchAllSum.toFixed(2) }} mm</span>
                        <span class="analysis-label selectable">Delta = {{
                            Math.abs(lowerAllDelta) }} mm</span>
                        <span class="analysis-label selectable"><b>{{ getAnalysis(lowerAllDelta) }}</b></span>
                    </label>
                </li>
            </div>
            <div class="arch-list-bottom">
                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn"
                    v-on:click="exportReportClick()">Export Report
                </button>

                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn"
                    v-on:click="exitArchMode(true)">Save
                    Arch Measurements
                </button>

                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn"
                    v-on:click="exitArchMode(false)">Exit Module
                </button>

                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn" v-on:click="close">Hide Panel
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import { switchShowLines, leaveArchMode, exportReport } from "./IntraoralArchMode.js";

export default {
    name: "IntraoralArchPanel",
    props: ["commonContext", "editContext"],
    data() {
        return {
            visibilities: [
            ],
        }
    },
    methods: {
        getAnalysis: function (delta) {
            let comment = delta <= 0 ? "Spacing" : "Crowding";
            return comment;
        },
        close: function () {
            console.log("close intraoralArchPanel");
            $(`#intraoralArchPanel`).removeClass("show");
        },
        setShowLines: function (event) {
            // this.editContext.showLines = !this.editContext.showLines;
            // if (event) {
            //     switchToggle(event.currentTarget.id, this.editContext.showLines);
            // }
            switchShowLines(this.editContext.showLines);
        },
        setSymmPoints: function (event) {
            // this.editContext.symmPoints = !this.editContext.symmPoints;
            // if (event) {
            //     switchToggle(event.currentTarget.id, this.editContext.symmPoints);
            // }
        },
        exportReportClick: function () {
            exportReport();
        },
        exitArchMode: function (saveChanges) {
            leaveArchMode(saveChanges);
        }
    },
    computed: {
        upperFirstSixDelta: function () {
            let delta = this.commonContext.upperTeethFirstSixSum - this.commonContext.upperArchFirstSixSum;
            return +delta.toFixed(2);
        },
        upperPremolarDelta: function () {
            let delta = this.commonContext.upperTeethPremolarSum - this.commonContext.upperArchPremolarSum;
            return +delta.toFixed(2);
        },
        upperAllDelta: function () {
            let delta = this.commonContext.upperTeethAllSum - this.commonContext.upperArchAllSum;
            return +delta.toFixed(2);
        },
        lowerFirstSixDelta: function () {
            let delta = this.commonContext.lowerTeethFirstSixSum - this.commonContext.lowerArchFirstSixSum;
            return +delta.toFixed(2);
        },
        lowerPremolarDelta: function () {
            let delta = this.commonContext.lowerTeethPremolarSum - this.commonContext.lowerArchPremolarSum;
            return +delta.toFixed(2);
        },
        lowerAllDelta: function () {
            let delta = this.commonContext.lowerTeethAllSum - this.commonContext.lowerArchAllSum;
            return +delta.toFixed(2);
        },
    },
}

</script>

<style scoped>
#ioArchPanel {
    display: none;
    position: absolute;
    top: 60px;
    right: 319px;
    z-index: 9;
    text-align: left;
    height: calc(100% - 107px);
    width: 0;
    font-family: Montserrat, sans-serif;
    font-size: small;
    background-color: red;
}

.btn {
    font-size: small;
}

.selectable {
    -moz-user-select: text;
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.setting-group {
    text-align: left;
    border: 1px solid #ced4da;
    align-items: end;
    border-radius: 0.2rem;
    padding-right: 5px;
}

.setting-ctrl {
    text-align: left;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.analysis-ctrl {
    text-align: left;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.bold-label {
    margin-right: 0.5rem;
    vertical-align: middle;
    font-size: bold;
}

.analysis-label {
    margin-right: 0.5rem;
    display: block;
    /* Позволяет задавать ширину и корректно переносить строки */
    /* max-width: 100%; */
    /* Гарантирует, что span не выйдет за рамки родителя */
    white-space: normal;
    /* vertical-align: middle; */
}

.check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}

.arch-panel {
    /* border-radius: 0.25rem;  */
    position: absolute;
    width: 250px;
    /* right: -40px; */
    top: 30px;
    max-height: calc(100% - 40px);
    overflow-y: scroll;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    /* border: solid 1px white; */
}

.arch-settings {
    width: 100%;
    background: #77a7fd;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}

.setting-item {
    text-align: center;
    padding: .3rem .4rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.setting-btn {
    margin: 2px 0;
    padding: 0;
}

.arch-list {
    background: white;
    /* #77a7fd; */
    overflow-y: scroll;
    /* max-height: calc(100% - 120px); */
    width: 100%;
    /* calc(100% - 1px); */
    /* margin-left: 1px;
    margin-top: 1px; */
}

.arch-list-bottom {
    padding-bottom: 8px;
    background-color: white;
    width: 100%;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.apply-btn {
    margin: 0px 5px 0 5px;
    width: calc(100% - 10px);
}

.cancel-btn {
    margin: 8px 5px 0px 5px;
    width: calc(100% - 10px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>